const defaultState: any = {}

const reportDetailsReducer = (state = defaultState, action: any) => {
    switch (action.type) {
        case 'SET_REPORT_DETAILS':
            return { ...state, data: action.payload };
        default:
            return state;
    }
}

export default reportDetailsReducer;
